module.exports = __webpack_public_path__ + "img/30-days-challenge-footer.58922219.webp";